import React, { useState } from "react";

interface Tab {
  id: string;
  label: string;
  content?: React.ReactNode;
}

interface TabsProps {
  tabs: Tab[];
  defaultActive?: string;
  onTabChange?: (id: string) => void;
}

const Tabs: React.FC<TabsProps> = ({ tabs, defaultActive, onTabChange }) => {
  const [activeTab, setActiveTab] = useState(defaultActive || tabs[0].id);

  const handleTabClick = (id: string) => {
    setActiveTab(id);
    if (onTabChange) onTabChange(id);
  };

  return (
    <div>
      {/* Tab Headers */}
      <div className="flex border-b border-gray-200">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => handleTabClick(tab.id)}
            className={`px-4 py-2 -mb-px text-sm font-medium rounded-t-md transition-colors duration-200
              ${
                activeTab === tab.id
                  ? "border-b-2 border-primary text-primary"
                  : "text-gray-500 hover:text-accent"
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="p-4">
        {tabs.find((t) => t.id === activeTab)?.content}
      </div>
    </div>
  );
};

export default Tabs;
